export enum PspCompanyEnum {
  Eva = 1,
  Lilly = 2,
  Roche = 3,
}
